module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAwBAMAAABER/HlAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURckWKv3/LN91Ks0mKvfmLNA4Kvr0LPLPK9RKKu6+K9leK+qtK+KEKuabK/Z+CGQAAADaSURBVDjLY2AYBXQBxkSpWkWUqt1EqUojRhGX4AIiVHELXiBCFYtgAhGqFgpKEKHqoqAsEaocBUUIK+IQFBRswKdASemQko4mUNUmIOOQEg5V4YLIoBi3wxFABrebHOGKRPC4zRKuajM+D6hBFSXhD4dCsCLxAPzBxQZW5UwgUBvBqkQJqDpIIBggAOou/IpYgUpcBAXF8LueR1BQ0niioKACXlXsgmIKDDyJghPwqgoUdAWSLYLCeFUpSoOpjUJ4VU2D5DKuTHyKmEthSc0Anyo4y2C0VKU5AAAuwSA9vVVzngAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/vn.png
// module id = bIkP
// module chunks = 34